import { useEffect, useRef, useState } from "react";

/* Kiosk scaler. Below the old column cap NOTHING changes: scale stays 1 and the game keeps
   its current fluid layout (phone/tablet untouched). On wide screens the game is locked to
   its designed width and transform-scaled up to fill the space — playfield, buttons and
   type all grow together, aspect ratio intact, capped by viewport height, and the scaled
   width never exceeds the container so there is no horizontal scroll at any width. */
export const GameScaler = ({ designWidth = 864, children }) => {
  const outerRef = useRef(null);
  const innerRef = useRef(null);
  const [box, setBox] = useState({ scale: 1, height: null, fluid: true });

  useEffect(() => {
    const measure = () => {
      const outer = outerRef.current;
      const inner = innerRef.current;
      if (!outer || !inner) return;
      const avail = outer.clientWidth;
      if (avail <= designWidth + 8) {
        setBox((b) => (b.fluid ? b : { scale: 1, height: null, fluid: true }));
        return;
      }
      const natural = inner.scrollHeight;
      const headroom = Math.max(480, window.innerHeight - 150);
      let scale = avail / designWidth;
      if (natural > 0) scale = Math.min(scale, Math.max(1, headroom / natural));
      setBox({ scale, height: natural * scale, fluid: false });
    };
    measure();
    const ro = new ResizeObserver(measure);
    if (outerRef.current) ro.observe(outerRef.current);
    if (innerRef.current) ro.observe(innerRef.current);
    window.addEventListener("resize", measure);
    return () => { ro.disconnect(); window.removeEventListener("resize", measure); };
  }, [designWidth]);

  return (
    <div ref={outerRef} data-testid="game-scaler" className="w-full"
      style={box.fluid ? undefined : { height: box.height, overflow: "hidden" }}>
      <div ref={innerRef}
        style={box.fluid ? undefined
          : { width: designWidth, transform: `scale(${box.scale})`, transformOrigin: "top center", margin: "0 auto" }}>
        {children}
      </div>
    </div>
  );
};
